import { KeyboardEvent } from 'react';
import { InputType } from './../EditComponent';
import { EntityType, SearchResult } from '../../../../store/Search';
import { SearchBox } from '../../Search/Search';

interface SearchBoxEditProps {
  localVal: InputType;
  handleSave: (
    value: InputType,
    e?: KeyboardEvent<HTMLDivElement> | KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
    displayValue?: string
  ) => void;
  handleClose: () => void;
  mapType?: string;
}

export const SearchBoxEditComponent = ({ localVal, handleSave, handleClose, mapType }: SearchBoxEditProps) => {
  const handleSelect = (result: SearchResult) => {
    const { id, title } = result;
    handleSave(id, undefined, title);
    handleClose();
  };

  return (
    <SearchBox
      handleSelect={handleSelect}
      searchEntityType={mapType as EntityType}
      inputString={String(localVal) || ''}
      placeholder={String(localVal) || ''}
      fullWidth
      inputFocus
    />
  );
};
